<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("services/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
        data() {
    return {

      headers: [
        { text: 'اسم المادة', value: 'description' },
        { text: 'الكمية ', value: 'quantity' },
        { text: 'السعر', value: 'price' },
      ],

    };
  },
  computed: {
    service() {
          return this.$store.state.services.service;
      }
  },
};
</script>